"use strict";
export var MobileEventName = /* @__PURE__ */ ((MobileEventName2) => {
  MobileEventName2["AutomatedOnDeviceRecoveryTriggered"] = "Automated On Device Recovery Triggered";
  MobileEventName2["AutomatedOnDeviceRecoveryMnemonicsFound"] = "Automated On Device Recovery Mnemonics Found";
  MobileEventName2["AutomatedOnDeviceRecoverySingleMnemonicFetched"] = "Automated On Device Recovery Mnemonic Fetched";
  MobileEventName2["DeepLinkOpened"] = "Deep Link Opened";
  MobileEventName2["ExploreFilterSelected"] = "Explore Filter Selected";
  MobileEventName2["ExploreSearchResultClicked"] = "Explore Search Result Clicked";
  MobileEventName2["ExploreTokenItemSelected"] = "Explore Token Item Selected";
  MobileEventName2["ExploreNetworkSelected"] = "Explore Network Selected";
  MobileEventName2["ExploreSearchNetworkSelected"] = "Explore Search Network Selected";
  MobileEventName2["FavoriteItem"] = "Favorite Item";
  MobileEventName2["FiatOnRampQuickActionButtonPressed"] = "Fiat OnRamp QuickAction Button Pressed";
  MobileEventName2["HomeExploreTokenItemSelected"] = "Home Explore Token Item Selected";
  MobileEventName2["NotificationsToggled"] = "Notifications Toggled";
  MobileEventName2["OnboardingCompleted"] = "Onboarding Completed";
  MobileEventName2["PerformanceReport"] = "Performance Report";
  MobileEventName2["ShareLinkOpened"] = "Share Link Opened";
  MobileEventName2["TokenDetailsOtherChainButtonPressed"] = "Token Details Other Chain Button Pressed";
  MobileEventName2["TokenDetailsContextMenuAction"] = "Token Details Context Menu Action Selected";
  MobileEventName2["WalletConnectSheetCompleted"] = "Wallet Connect Sheet Completed";
  MobileEventName2["WidgetClicked"] = "Widget Clicked";
  MobileEventName2["WidgetConfigurationUpdated"] = "Widget Configuration Updated";
  return MobileEventName2;
})(MobileEventName || {});
export var MobileAppsFlyerEvents = /* @__PURE__ */ ((MobileAppsFlyerEvents2) => {
  MobileAppsFlyerEvents2["OnboardingCompleted"] = "onboarding_complete";
  MobileAppsFlyerEvents2["SwapCompleted"] = "swap_completed";
  MobileAppsFlyerEvents2["WalletFunded"] = "wallet_funded";
  return MobileAppsFlyerEvents2;
})(MobileAppsFlyerEvents || {});
